<template>
  <div>
    <div class="content">
      <div class="contentL">
        <div class="contentLtitle">组织结构</div>
        <!-- <el-tree :data="dataList" highlight-current :props="defaultProps"  @node-click="handleCheckChange"></el-tree> -->
        <!-- <el-tree :data="dataList" highlight-current  :props="defaultProps" @node-click="handleNodeClick" class="custom-tree"></el-tree> -->
        <el-input class="inputValue" v-model="inputValue" placeholder="请输入关键词搜索" @click="handleSearch"
          suffix-icon="el-icon-search">
        </el-input>
        <div class="tree-container">
          <!-- <el-checkbox v-model="selectAll" @change="handleSelectAll" class="customSelect">{{ selectAllText
          }}</el-checkbox> -->
          <el-tree ref="tree" :default-expand-all="false" :show-checkbox="false" :data="treeData" :check-on-click-node="false
            " :props="defaultProps" node-key="id" @node-click="handleCheck"></el-tree>
        </div>

      </div>
      <div class="contentR">
        <div class="prompt">
          <img src="../../assets/images/LTicon.png" alt="">
          <div class="promptText">检修计划</div>
        </div>
        <div class="searchContent">
          <div class="search">
            <div class="formList">
              <el-form :inline="true" :model="formInline" class="demo-form-inline">

                <el-form-item label="计划名称：">
                  <el-input v-model="formInline.title" placeholder="请输入关键词" class="custom-input"></el-input>
                </el-form-item>
                <!-- <el-form-item label="手机号：">
                  <el-input v-model="formInline.content" placeholder="请输入手机号" class="custom-input"></el-input>
                </el-form-item> -->
                <el-form-item label="计划开始时间：">
                  <el-date-picker v-model="formInline.content" type="date" placeholder="选择日期"></el-date-picker> <span> ~
                  </span>
                  <el-date-picker v-model="formInline.createBy" type="date" placeholder="选择日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="巡检状态">
                  <el-select class="custom-select" :popper-append-to-body="false" v-model="formInline.updateTime" placeholder="请选择">
                    <el-option label="全部" value="shanghai"></el-option>
                    <el-option label="执行中" value="beijing"></el-option>
                    <el-option label="已完成" value="1"></el-option>
                    <el-option label="已终止" value="2"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="onSubmit" icon="el-icon-search" class="custom-button">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div class="newView">
              <el-button type="primary" @click="replyDialog(0)" icon="el-icon-plus"
                class="custom-button">添加检修计划</el-button>
              <el-button type="primary" @click="openViewDialog('',0)" icon="el-icon-download"
                class="custom-button">导出</el-button>
            </div>
          </div>
        </div>
        <div class="table">
          <el-table border :data="tableData" style="width: 100%" class="custom-table">
            <el-table-column align="center" label="序号" type="index" width="150">
            </el-table-column>
            <el-table-column align="center" prop="name" label="变配电站" width="200">
            </el-table-column>
            <el-table-column align="center" prop="model" label="计划名称" :fluid="true">
            </el-table-column>
            <el-table-column align="center" prop="number" label="巡视路线" width="300">
            </el-table-column>
            <el-table-column align="center" prop="number2" label="巡检单" width="300">
            </el-table-column>
            <el-table-column align="center" prop="email" label="计划开始时间" width="200">
            </el-table-column>
            <el-table-column align="center" prop="email1" label="巡视周期" width="200">
            </el-table-column>
            <el-table-column align="center" prop="email2" label="巡视工期(天)" width="200">
            </el-table-column>
            <el-table-column align="center" prop="email3" label="计划结束时间" width="200">
            </el-table-column>
            <el-table-column align="center" prop="email4" label="状态" width="200">
            </el-table-column>
            <el-table-column align="center" prop="email5" label="任务派发人" width="200">
            </el-table-column>
            <el-table-column align="center" prop="data" fixed="right" label="操作" width="150">
              <template slot-scope="scope">
                <el-button @click="replyDialog(scope.row)" type="text">查看</el-button><span>|</span>
                <el-button @click="openViewDialog(scope.row,1)" type="text">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination">
          <div class="btn" @click="startHome">首页</div>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="prev, pager, next, sizes"
            :prev-text="prevButtonText" :next-text="nextButtonText" prev-button-class="custom-prev-button"
            next-button-class="custom-next-button" :total="total">
          </el-pagination>
          <div class="btn endBtn" @click="endHome">尾页</div>
          <div class="paginationEnd">
            <div>跳</div>至
            <el-input size="mini" @change="paginationEnd" class="paginationEndIpt"
              v-model.number="paginationEndIpt"></el-input>
            <div>页</div>
            <div class="btn confirm" @click="jumpPage">确定</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 新建意见弹窗 -->
    <el-dialog title="添加巡视计划" :visible.sync="centerDialogVisible" width="35%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
        <el-form-item label="计划名称" prop="dictName">
          <el-input placeholder="请输入计划名称" v-model="ruleForm.dictName" class="my-custom"></el-input>
        </el-form-item>
        <el-form-item label="检修路线" prop="dictCode">
          <el-select  class="custom-select" :popper-append-to-body="false" v-model="ruleForm.dictCode" placeholder="请选择检修路线">
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="计划开始时间：" prop="dictName">
          <el-date-picker class="custom-picker" v-model="ruleForm.dictName" type="date" placeholder="请选择计划开始时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="计划结束时间：" prop="dictName">
          <el-date-picker class="custom-picker" v-model="ruleForm.dictName" type="date" placeholder="请选择计划结束时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="巡视周期规则" prop="dictCode">
          <el-select  class="custom-select" :popper-append-to-body="false" v-model="ruleForm.dictCode" placeholder="请选择巡检周期">
            <el-option label="按日" value="shanghai"></el-option>
            <el-option label="按周" value="beijing"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="检修周期" prop="dictName">
          <el-input placeholder="请输入检修周期" v-model="ruleForm.dictName" class="my-custom"></el-input>
        </el-form-item>
        <el-form-item label="检修周期" prop="dictName">
          <el-input placeholder="请输入检修周期" v-model="ruleForm.dictName" class="my-custom"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="">
          <el-input type="textarea" class="my-custom" :rows="4" v-model="ruleForm.dictDesc"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <!-- <div class="">取消</div>
          <div class="">确定</div> -->
        <el-button class="dialogBtn" @click="centerDialogVisible = false">取 消</el-button>
        <el-button class="dialogBtn" type="primary" @click="centerDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 删除 -->
    <el-dialog :title="deleteDialogType==0?'导出':'删除'" :visible.sync="replyDialogVisible" width="20%">

      <div class="deleteCenter">
        <!-- 确定删除该条信息? -->
        {{ deleteDialogType==0?'确定要下载该文件吗？':'确定要删除该文件吗？' }}
      </div>

      <span slot="footer" class="dialog-footer">

        <el-button class="dialogBtn" @click="replyDialogVisible = false">取 消</el-button>
        <el-button class="dialogBtn" type="primary" @click="replyDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { boardList } from '../../api/dailyWork.js'
// import demo from "./demo.vue"
export default {
  name: 'Administration',
  data() {
    return {
      formInline: {
        title: '',//标题
        content: '',//内容
        createBy: '',//创建人
        updateTime: '',//创建时间
      },
      tableData: [
        {
          name: '变配电站名称1',
          model: '计划名称',
          number: '巡视路线',
          number2: '巡检单名称',
          email: '2022-03-30',
          email1: '1月',
          email2: '1',
          email3: '2022-03-30',
          email4: '执行中',
          email5: '超级管理员',
        },
        {
          name: '变配电站名称2',
          model: '计划名称',
          number: '巡视路线',
          number2: '巡检单名称',
          email: '2022-03-30',
          email1: '1月',
          email2: '1',
          email3: '2022-03-30',
          email4: '执行中',
          email5: '超级管理员',
        },
        {
          name: '变配电站名称3',
          model: '计划名称',
          number: '巡视路线',
          number2: '巡检单名称',
          email: '2022-03-30',
          email1: '1月',
          email2: '1',
          email3: '2022-03-30',
          email4: '执行中',
          email5: '超级管理员',
        },


      ],
      deleteDialogType: 0 ,
      centerDialogVisible: false,
      replyDialogVisible: false,
      prevButtonText: '上一页',
      nextButtonText: '下一页',
      paginationEndIpt: '',
      pageSize: 10,
      currentPage: 1,
      total: 40,
      textarea: '',

      treeData: [
        {
          id: 1,
          label: '分中心名称1',
          children: [
            {
              id: 11,
              label: '场站名称1',
              children: [
                { id: 111, label: '配电室' },
                { id: 112, label: '箱变' },
                { id: 113, label: '柱变' },
                {
                  id: 114, label: '强电间',
                  children: [
                    { id: 1141, label: '高压侧' },
                    { id: 1142, label: '低压侧' },
                    { id: 1143, label: '变压器' },
                    { id: 1144, label: '直流屏' },
                  ]
                },
              ],
            },
            {
              id: 12,
              label: '场站名称2',
              children: [
                { id: 121, label: '配电室' },
                { id: 122, label: '箱变' },
                { id: 123, label: '柱变' },
                { id: 124, label: '强电间', }

              ]

            },
          ],
        },
        {
          id: 2,
          label: '分中心名称2',
          children: [
            {
              id: 21,
              label: '场站名称1',
              children: [
                { id: 211, label: '配电室' },
                { id: 212, label: '箱变' },
                { id: 213, label: '柱变' },
                { id: 214, label: '强电间', }

              ]
            },
            {
              id: 22,
              label: '场站名称2',
              children: [
                { id: 221, label: '配电室' },
                { id: 222, label: '箱变' },
                { id: 223, label: '柱变' },
                { id: 224, label: '强电间', }

              ]
            },
          ],
        },
      ],
      checkedNodes: [],
      selectAll: false,
      selectAllText: '全选',
      treeTitle: [],
      treeText: '',
      selectContent: '',
      inputValue: '',
      defaultProps: {
        children: 'children',
        id: 'id',
        label: 'label'
      },
      ruleForm: {
        dictName: '',
        dictCode: '',
        state: '',
        dictDesc: '',
        dictLevel: 1

      },
      rules: {
        dictName: [
          { required: true, message: '请输入文件类型', trigger: 'blur' },
        ],
        dictCode: [
          { required: true, message: '请选择文件', trigger: 'blur' },
        ],

      }


    };
  },
  // components:{demo},

  mounted() {
    // let pageText = document.getElementsByClassName('el-pagination__jump')[0]
    // pageText.childNodes[0].nodeValue = '跳至'
    // pageText.childNodes[2].nodeValue = '页'
    // this.getList()

  },
  computed: {

  },


  methods: {
    // tree搜索
    handleSearch() {

    },
    handleCheck(checkedNodes, event) {
      this.checkedNodes = checkedNodes;
      // this.updateSelectAllState();
      console.log(this.checkedNodes);
    },
    //列表查询
    getList() {
      let obj = {
        ...this.formInline,
        page: this.currentPage,
        pageSize: this.pageSize
      }
      boardList(obj).then(res => {
        // console.log(res);
        if (res.code == 200) {
          this.tableData = res.data
        }
      })
    },
    //查看
    replyDialog(el) {
      console.log(el.data);
      this.centerDialogVisible = true
    },
    //查询列表
    onSubmit() {
      console.log('submit!');
    },

    //打开意见弹窗
    openViewDialog(el,type) {
      console.log(el);
      this.replyDialogVisible = true
      this.deleteDialogType=type

    },
    //分页相关function
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val
      this.paginationEnd()
      this.getList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.paginationEndIpt = val
      console.log(`当前页: ${val}`);
      console.log(this.currentPage);
      this.getList()
    },
    //首页
    startHome() {
      this.currentPage = 1

    },
    //尾页
    endHome() {
      const lastPage = Math.ceil(this.total / this.pageSize);
      this.currentPage = lastPage;
    },
    //页数输入时
    paginationEnd() {
      const lastPage = Math.ceil(this.total / this.pageSize);
      this.paginationEndIpt = this.paginationEndIpt < lastPage ? this.paginationEndIpt : lastPage
    },
    //跳转
    jumpPage() {
      this.currentPage = this.paginationEndIpt
      // this.paginationEndIpt=''
    },
    //点击父节点
    titleTree(item) {
      // this.treeTitle.push(item.label)
      // this.treeTitle = [...new Set(this.treeTitle)];
      console.log(this.treeTitle);
      // const index = this.treeTitle.findIndex(item => item.label === item.label);
      const index = this.treeTitle.indexOf(item.label);
      if (index !== -1) {
        // 对象已存在于数组中，删除它
        this.treeTitle.splice(index, 1);
      } else {
        // 对象不存在于数组中，添加它
        this.treeTitle.push(item.label);
      }

    },
    // 点击子节点
    treeContent(item, content) {
      console.log(item, content);
      this.treeText = item.label

      this.selectContent = content.label
    }


  },
};
</script >
<style src="@/utils/style/table.css" scoped></style>
<style scoped>
/* import */
.content {
  width: 100%;
  height: 100%;
  background: url(../../assets/images/routerImg.png);
  background-repeat: no-repeat;
  background-position: left left;
  background-size: cover;
  font-size: 16px;
  display: flex;

}

.contentL {
  width: 400px;
  margin-top: 10px;
  padding: 28px 0 60px 17px;
  box-sizing: border-box;
  /* background: #071536; */

}

.contentR {
  width: 100%;
  overflow: auto;
}

.prompt {
  padding: 28px 0 0 17px;
  font-size: 16px;
  color: #ebf4ff;
  display: flex;
  align-items: center;
}

.promptText {
  margin-left: 10px;
}

.el-input>>>.el-input__inner {
  background-color: #061b45;
  border: 1px solid #09295b;
  color: #AED6FF;
}

.el-form-item>>>.el-form-item__label {
  font-size: 12px;
  color: #AED6FF;
}

.custom-input ::placeholder {
  color: #AED6FF;
}

.custom-button {
  background: #176ad2;
}

.searchContent {
  margin: 11px 25px 16px 26px;
}

.search {
  display: flex;
  justify-content: space-between;
  padding: 14px 26px 13px 20px;
  background: #061C45;
}

.custom-pager-text {
  margin-right: 5px;
}

.custom-page-input {
  width: 60px;
  margin-right: 5px;
}

.custom-page-button {
  padding: 5px 10px;
}


.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 21px;
}

.btn {
  width: 60px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  background: rgba(255, 255, 255, 0);
  border: 1px solid #0b2653;
  border-radius: 2px;
  color: #92b5da;

}

.btn:hover {
  color: #ffffff;
}

.el-pagination>>>.btn-prev,
.el-pagination>>>.btn-next {
  background: rgba(255, 255, 255, 0);
  color: #d7d7d7;
  border-radius: 2px;
  border: 1px solid #0b2653;
  margin-right: 5px;
}

.el-pagination>>>.el-pager li {
  background: rgba(255, 255, 255, 0);
  color: #d7d7d7;
  border-radius: 2px;
  border: 1px solid #0b2653;
  margin-right: 5px;
}

.el-pagination>>>.el-pager .active {
  background: #176AD2;
  color: #d7d7d7;
  border-radius: 2px;
  border: 1px solid #0b2653;
  margin-right: 5px;
}

::v-deep .el-input__inner {
  background: rgba(255, 255, 255, 0);
  color: #d7d7d7;
  border-radius: 2px;
  border: 1px solid #0b2653;

}

.endBtn {
  margin-left: -15px;
  margin-right: 10px;
}

.paginationEnd {
  display: flex;
  justify-content: center;
  align-items: center;
}

.paginationEndIpt {
  width: 30px;
  margin: 0 7px;
  padding: 0;
  color: #92b5da;
  /* height: 16px; */
}

.paginationEndIpt>>>.el-input__inner {
  padding: 0 5px;
}

.confirm {
  margin-left: 10px;
  background: #176AD2;
  color: #d7d7d7;
}

/* 弹窗 */
::v-deep .el-dialog {
  background-color: #071734;
  font-size: 16px;
}

::v-deep .el-dialog__header {
  background: #05153A;
  border-bottom: 1px solid #09295b;
}

::v-deep .el-dialog__title {
  font-size: 16px;
  color: #fff;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  font-size: 16px;
  color: #000;
}

.dialogBtn {
  width: 100px;
  height: 35px;
  background: #2142A1;
  border: 0;
  color: #fff;
}

.newCenter {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.newCenterText {
  width: 80px;
  color: #C9D4D4;
}

::v-deep .el-textarea__inner {
  background-color: #061D4A;
  color: #AED6FF;
  border: 1px solid #09295b;
}

.custom-input-textarea ::placeholder {
  color: #667597;
}

.newCenterKey {
  width: 50px;
  color: #C9D4D4;
}

/* tree样式修改 */
::v-deep .el-tree {
  background: #03183F !important;
  color: #aed6ff;
  padding-bottom: 10px;
}


::v-deep .el-tree-node {
  background: #03183F !important;
  color: #aed6ff;
}

::v-deep .is-current {
  background: #03183F !important;
  color: #FFC74A;
}

::v-deep .is-checked {
  background: #03183F !important;
  /* color: #FFC74A; */
}

::v-deep .el-tree-node__content:hover {
  background: #03183F;
  /* color: #FFC74A; */
}

::v-deep .el-tree-node__content:focus {
  background: #03183F !important;
}

::v-deep.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  background-color: #03183F;
}

::v-deep .el-tree-node {
  background-color: #03183F;

}

.tree {
  margin-top: 21px;
  /* background: #071734 ; */
  color: #aed6ff;

}

.treeContent {
  height: 32px;
  line-height: 32px;
  padding-left: 62px;
  font-size: 14px;
}

.treeContent:hover {
  color: #FFC74A;
}

.selectContent {
  color: #FFC74A;
}

.treeTitle {
  height: 32px;
  line-height: 32px;
  margin-left: 32px;
  display: flex;
  align-items: center;
  font-size: 14px;
}

.treeTitle img {
  width: 10px;
  height: 7px;
  margin-right: 5px;

}

.titleImg {
  transform: rotate(90deg);
}

.contentLtitle {
  color: #d8e3ff;
  font-size: 14px;
  margin-bottom: 20px;
}

.customSelect {
  color: #d8e3ff;
  margin-bottom: 10px;
}

::v-deep .el-tree-node:focus>.el-tree-node__content {
  background-color: #03183F !important;
}

::v-deep .el-checkbox__inner {
  background-color: rgba(255, 255, 255, 0);
  border: 1px solid #083B7A;
  /* background-color: rgba(255, 255, 255, 0); */
}

.inputValue {
  width: 210px;
  margin-bottom: 10px;
}

.deleteCenter {
  font-size: 16px;
  color: #EBEDF1;
}

.custom-select>>>.el-select-dropdown {
  background: #041C4C !important;
  border: 1px solid #09295b;
  color: #aed6ff;
}

::v-deep .el-select-dropdown__item.hover {
  background: #041C4C !important;
  color: #fff;
}

::v-deep .el-select-dropdown__item {
  color: #aed6ff;
}

::v-deep .el-select-dropdown__item.selected {
  color: #fff;
}

::v-deep .el-popper[x-placement^=bottom] .popper__arrow::after {
  top: 0;
  border-bottom-color: #041C4C;
}

.el-select {
  width: 100%;
}
.custom-picker {
  width: 100%;
  /* background: #05153A; */
}
.custom-picker >>> .el-input__inner{
  background: #071734;
  
}
.my-custom >>> .el-input__inner{
  background: #071734;
}
.my-custom >>> .el-textarea__inner{
  background: #071734;
}
</style>